<div class="col-12 nex-steps-5" [ngClass]="{'nex-steps-5': hasSignature, 'nex-steps-4': !hasSignature}">
  <p-steps [model]="process" [(activeIndex)]="activeIndex"></p-steps>
</div>
<div class="col-12">
  <div class="col-4 align-left">
    <!--<button [disabled]="!previousEnabled()" type="button" [icon]="'fa fa-hand-o-left'"
            [label]="'COMMON.PREVIOUS' | translate" pButton (click)="previousStep()"></button>-->
  </div>
  <div class="col-4 align-center">
    <!--<button *ngIf="currentStep === 'REVIEW'" type="button" [icon]="'fa fa-check'" class="p-button-warning" [iconPos]="'right'"
            [label]="'UPLOAD_COMPONENT.ADD_ADDRESS_PAGE' | translate" pButton (click)="addAddressPage()"></button>-->
  </div>
  <div class="col-4 align-right">
    <!--    <button *ngIf="currentStep !== 'REVIEW'" [disabled]="!nextEnabled()" type="button" [icon]="'fa fa-hand-o-right'"
                [label]="'COMMON.NEXT' | translate" pButton (click)="nextStep()"></button>-->
    <button *ngIf="currentStep === 'REVIEW'" type="button" [icon]="'fa fa-check'" class="p-button-warning"
            [iconPos]="'right'"
            [label]="'COMMON.VALIDATE' | translate" pButton (click)="saveExpressDeposit()"></button>
  </div>


</div>
<div class="col-12" *ngIf="currentStep === 'PARAMS'">
  <app-deposit-options [depositType]="DepositDepotExpressEnum.MAILING" (moveNext)="nextStep()" (signatureChange)="setSignatureFile($event)"
                       (depositDirChange)="setDepositDir($event)"
                        (hasMailingChange)="setHasMailing($event)"></app-deposit-options>


</div>
<div class="col-12" *ngIf="currentStep === 'DATA'">
  <div class="col-12 align-right">
    <button [disabled]="!nextEnabled()" type="button" [icon]="'fa fa-hand-o-right'"
            [label]="'COMMON.NEXT' | translate" pButton (click)="nextStep()"></button>
  </div>
  <div class="col-3">
    <div class="col-12">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.DATA_FILE_SELECTION' | translate">
        <div class="col-12">
          <div class="col-6">
            <button pButton type="button" [label]="'UPLOAD_COMPONENT.DATA_FILE_MODEL_DOWNLOAD' | translate"
                    class="p-button-success" tooltipPosition="right"
                    [pTooltip]="'UPLOAD_COMPONENT.DATA_FILE_MODEL_DOWNLOAD_TOOLTIP' | translate"
                    (click)="downloadModel()"></button>
          </div>
          <div class="col-6" (click)="showColumnHelp()">
            <i class="fa fa-question-circle cols-tool-tip-button"></i>
          </div>
        </div>

        <div class="col-12">
          <app-files-upload filesTitle=""
                            [moreThanOneFile]="false"
                            [acceptedFiles]="getListOfAcceptedFiles(FileStatus.DATA)"
                            [optional]="false"
                            [shouldClearFiles]="shouldClearFiles"
                            (isValid)="updateUploadValidity(FileStatus.DATA,$event)"
                            (selectedFiles)="setDataFile(FileStatus.ANNEX,$event)"></app-files-upload>
        </div>
      </p-fieldset>
    </div>
    <div class="col-12" *ngIf="availableMetaColumns && availableMetaColumns.length > 0">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.METADATA_SELECTION' | translate">
        <div class="col-12"
             *ngIf="availableMeta && availableMeta.length > 1">
          <div class="col-5">
            <div class="col-12">
              {{'UPLOAD_COMPONENT.METADATA_LABELS_FIELD' | translate}}
            </div>
            <div class="col-12">
              <p-dropdown appendTo="body" [options]="availableMeta" [(ngModel)]="newMeta.field"></p-dropdown>
            </div>
          </div>
          <div class="col-5">
            <div class="col-12">
              {{'UPLOAD_COMPONENT.METADATA_LABELS_COLUMN' | translate}}
            </div>
            <div class="col-12">
              <p-dropdown appendTo="body" [options]="availableMetaColumns" [(ngModel)]="newMeta.column"></p-dropdown>
            </div>
          </div>
          <div class="col-2">
            <div class="col-12">&nbsp;</div>
            <div class="col-12">
              <button pButton type="button" [icon]="'fa fa-plus'"
                      [pTooltip]="'UPLOAD_COMPONENT.METADATA_ADD_LABEL' | translate"
                      class="p-button-info" (click)="addMeta()"></button>
            </div>
          </div>
          <!--<div class="col-2"><i class="fa fa-save clickable p-button-success" aria-hidden="true"
                                 (click)="addMeta(newMeta)"
                                 title="{{ 'UPLOAD_COMPONENT.METADATA_ADD_LABEL' | translate }}"></i></div>-->
        </div>
        <div class="col-12" *ngIf="metaDataList.length >0">
          <p-table [value]="metaDataList" selectionMode="single" [scrollable]="true" scrollHeight="540px">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 45.6667%">{{'UPLOAD_COMPONENT.METADATA_LABELS_FIELD' | translate}}</th>
                <th style="width: 45.6667%">{{'UPLOAD_COMPONENT.METADATA_LABELS_COLUMN' | translate}}</th>
                <th style="width: 8.6667%"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
              <tr>
                <td style="width: 45.6667%">{{getMetaLabel(rowData.field)}}</td>
                <td style="width: 45.6667%">{{rowData.column}}</td>
                <td style="width: 8.6667%">
                  <button pButton type="button" [icon]="'fa fa-trash-o'" class="p-button-danger"
                          (click)="removeMeta(rowData)"
                          [title]="'UPLOAD_COMPONENT.METADATA_REMOVE_LABEL' | translate "></button>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-fieldset>
    </div>
  </div>
  <div class="col-9">
    <p-fieldset [legend]="'UPLOAD_COMPONENT.DATA_FILE_PREVIEW' | translate">
      <div class="col-4">
        <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_COUNT' | translate}}:</div>
        <div class="col-2"> {{mailingData.length}}</div>
      </div>
      <div class="col-4">
        <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_VALID' | translate}}:</div>
        <div class="col-2"> {{mailingDataValidRows}}</div>
      </div>
      <div class="col-4">
        <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_INVALID' | translate}}:</div>
        <div class="col-2"> {{mailingDataInValidRows}}</div>
      </div>
      <div *ngIf="hasMailing" class="col-4">
        <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_COUNT_MAIL' | translate}}:</div>
        <div class="col-2"> {{mailingData.length}}</div>
      </div>
      <div *ngIf="hasMailing" class="col-4">
        <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_VALID_MAIL' | translate}}:</div>
        <div class="col-2"> {{mailingDataValidMailRows}}</div>
      </div>
      <div *ngIf="hasMailing" class="col-4">
        <div class="col-10">{{'UPLOAD_COMPONENT.DATA_FILE_ROWS_INVALID_MAIL' | translate}}:</div>
        <div class="col-2"> {{mailingDataInValidMailRows}}</div>
      </div>
      <div class="col-3" *ngIf="((mailingData.length >0 && mailingDataInValidRows > 0) )">
        <button pButton type="button" [label]="'UPLOAD_COMPONENT.DELETE_INVALID_ROWS_LABEL' | translate"
                class="p-button-success"
                (click)="removeInvalidMailingRows()"
                [pTooltip]="'UPLOAD_COMPONENT.DELETE_INVALID_ROWS_TOOLTIP' | translate"></button>
      </div>
      <div class="col-12">
        <p-table *ngIf="showMailingData" [value]="mailingData"
                 selectionMode="single" [scrollable]="true" scrollHeight="540px" dataKey="id">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 4em">{{ 'UPLOAD_COMPONENT.MAILING_FIELDS.LINE_NB' | translate }}</th>
              <th [pSortableColumn]="'valid'" style="width: 6em">{{ 'UPLOAD_COMPONENT.MAILING_FIELDS.VALIDITY' | translate }}</th>
              <th>{{ 'UPLOAD_COMPONENT.MAILING_FIELDS.POSTAL_ADDRESS' | translate }}</th>
              <th *ngIf="showMailingDataMail && hasMailing" [pSortableColumn]="'validMail'" style="width: 6em">
                {{ 'UPLOAD_COMPONENT.MAILING_FIELDS.VALIDITY' | translate }}</th>
              <th *ngIf="showMailingDataMail && hasMailing">{{ 'UPLOAD_COMPONENT.MAILING_FIELDS.EMAIL_ADDRESS' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr>
              <td style="width: 4em">{{rowIndex + 1}}</td>
              <td style="width: 6em">
                <button *ngIf="rowData.isValid()" class="p-button-success" type="button" [icon]="'fa fa-check'"
                        [pTooltip]="'COMMON.ADDRESS_IS_VALID' | translate" pButton></button>
                <button *ngIf="!rowData.isValid()" class="p-button-warning" type="button" [icon]="'fa fa-pencil'"
                        [pTooltip]="'COMMON.CORRECT_ADDRESS' | translate" pButton (click)="editMailingAddress(rowData)"></button>
                <button *ngIf="!rowData.isValid()" class="p-button-danger" type="button" [icon]="'fa fa-close'"
                        [pTooltip]="'COMMON.DELETE' | translate" pButton (click)="removeMailingAddress(rowData)"></button>
              </td>
              <td [ngClass]="rowData.isValid() ? null : 'invalid-address'">{{ formatAddress(rowData) }}</td>
              <td *ngIf="showMailingDataMail && hasMailing" style="width: 6em">
                <button *ngIf="rowData.isValidMail() && hasMailing" class="p-button-success" type="button" [icon]="'fa fa-check'"
                        [pTooltip]="'COMMON.EMAIL_IS_VALID' | translate" pButton></button>
                <button *ngIf="!rowData.isValidMail() && hasMailing" class="p-button-warning" type="button" [icon]="'fa fa-pencil'"
                        [pTooltip]="'COMMON.CORRECT_EMAIL' | translate" pButton (click)="editEmail(rowData.recipientMail, rowIndex)"></button>
                <button *ngIf="!rowData.isValidMail() && hasMailing" class="p-button-danger" type="button" [icon]="'fa fa-close'"
                        [pTooltip]="'COMMON.DELETE' | translate" pButton (click)="removeMailingAddress(rowData)"></button>
              </td>
              <td *ngIf="showMailingDataMail && hasMailing" [ngClass]="rowData.isValidMail() ? null : 'invalid-address'">{{ rowData.recipientMail }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-fieldset>
  </div>
</div>
<div class="col-12" *ngIf="currentStep === 'TEMPLATE'">
<!--  <div class="col-12" style="font-size: 1.3em">
    <p-radioButton name="depositType" value="USER_PDF" (onClick)="showModelBrowser()"
                   [label]="'UPLOAD_COMPONENT.MAIN_MODEL_SELECTION' | translate"
                   inputId="depopt1"></p-radioButton>
  </div>-->
<!--  <div class="col-12" style="font-size: 1.3em">
    <p-radioButton name="depositType" value="LOOL_ODT" (onClick)="openEditor()"
                   [label]="'UPLOAD_COMPONENT.MAIN_MODEL_CREATION' | translate"
                   inputId="depopt2"></p-radioButton>
  </div>-->

  <!--<p-fieldset [legend]="'UPLOAD_COMPONENT.MAIN_FILE_SELECTION' | translate">-->
  <div class="col-3" *ngIf="templateSource === 'USER_PDF'">
    <app-files-upload
      [filesTitle]="'UPLOAD_COMPONENT.MAIN_MODEL_SELECTION' | translate"
      [moreThanOneFile]="false"
      [acceptedFiles]="['doc', 'docx', 'pdf', 'odt']"
      [optional]="false"
      [shouldClearFiles]="shouldClearFiles"
      (isValid)="updateUploadValidity(FileStatus.MAIN,$event)"
      (selectedFiles)="setMainFile(FileStatus.MAIN,$event)">
    </app-files-upload>
  </div>
  <!--<div class="col-12" *ngIf="templateSource === 'LOOL_ODT'">
    <button pButton type="button" [label]="'UPLOAD_COMPONENT.CREATE_MAILING_MODEL' | translate"
            class="p-button-success"
            (click)="doCreateNewModel()"></button>
  </div>-->
  <!--</p-fieldset>-->
</div>
<div class="col-12" *ngIf="currentStep === 'FORMATTING'">
  <app-signature-options [signature]="signature" [depositDir]="depositDir" [pagesImages]="pagesImages"
                         [pageCount]="pageCount" [pages]="pages"
                         [sigPages]="sigPages" (stored)="signaturePositionStored($event)"></app-signature-options>
</div>
<div class="col-12" *ngIf="currentStep === 'REVIEW'">
  <app-deposit-review type="MAILING" [depositDir]="depositDir" [customizedFilePdf]="customizedFilePdf"
                      [foldCount]="foldCount"></app-deposit-review>
  <!--<div class="col-3">
    <div class="col-12">
      <button type="button" [icon]="'fa fa-search'"
              [label]="'UPLOAD_COMPONENT.DOWNLOAD_FINAL' | translate" pButton
              (click)="loadVisualization(true)"></button>
    </div>
  </div>
  <div class="col-6 viewer-container">
    <div class="col-12">
      <p-paginator [rows]="1" [totalRecords]="foldCount" showCurrentPageReport="true"
                   [currentPageReportTemplate]="'Pli:  {currentPage} sur {totalPages}'"
                   (onPageChange)="prepareMailingFinalFile($event)">
      </p-paginator>
    </div>
    <object *ngIf="pdfToDisplay && !msBrowsers" [data]="pdfToDisplay + '#view=FitH&zoom=100' | safeObjUrl"
            type="application/pdf" width="100%"
            height="100%"></object>
  </div>
  <div class="col-3"></div>-->
</div>
<div *ngIf="showEditMailingAddress">
  <p-dialog [styleClass]="'express-address-dialog'" [appendTo]="'body'" [(visible)]="showEditMailingAddress"
            [header]="'Je modifie l\'adresse du courrier sélectionné'"
            [draggable]="true"
            [closable]="true"
            [maximizable]="true"
            [modal]="true" [closeOnEscape]="true">
    <app-express-address (finalAddress)="updateMailingAddress($event)"
                         (visible)="handleDestAddressClose($event)"
                         [objAddress]="selectedMailingAddress"
                         [lines]="selectedMailingAddressLines"></app-express-address>
    <!-- <a href="pdfToDisplay">Download PDF</a>-->
  </p-dialog>
</div>

<div *ngIf="showEditEmailAddress">
  <p-dialog [styleClass]="'express-address-email-dialog'" [appendTo]="'body'" [(visible)]="showEditEmailAddress"
            [header]="'Je corrige l\'adresse mail du courrier sélectionné'"
            [draggable]="true"
            [closable]="true"
            [maximizable]="true"
            [modal]="true" [closeOnEscape]="true">
        <app-email-address (finalAddressMail)="updateEmailAddress($event)"
                       [recipient]="selectedMailingAddress.email"
                       [index]="selectedMailingAddress.index"> </app-email-address>
  </p-dialog>
</div>
<!--<div *ngIf="showEditingModel">
  <p-dialog [styleClass]="'edit-mailing-model-dialog'" [appendTo]="'body'" [(visible)]="showEditingModel"
            [header]="'Je crée un nouveau modèle de courrier '"
            [draggable]="true"
            [closable]="true"
            [maximizable]="true"
            [modal]="true" [closeOnEscape]="true">
    <app-create-mailing-model [draggableColumns]="mailingColumns" [modelId]="modelToEdit" (customerModels)="updateModels($event)"></app-create-mailing-model>

  </p-dialog>
</div>-->
<div *ngIf="showMailingModelEditor">
  <p-dialog [styleClass]="'edit-mailing-model-editor-dialog'" [appendTo]="'body'" [(visible)]="showMailingModelEditor"
            [header]="'Je crée un nouveau modèle de courrier '"
            [draggable]="false"
            [closable]="true"
            [maximizable]="false"
            [modal]="true" [closeOnEscape]="true" (close)="editorClosed()">
    <app-mailing-model-editor [draggableColumns]="mailingColumns" [loolLink]="externalLink"
                              (closeDialogue)="closeEditor()"></app-mailing-model-editor>
  </p-dialog>
</div>
<div class="saving-loader-modal">
  <p-dialog [appendTo]="'body'" [(visible)]="displayLoading" [header]="'UPLOAD_COMPONENT.LOADER_TITLE' | translate"
            id="ex-save-loader" [draggable]="false" [closable]="false" [resizable]="false"
            [modal]="true" [closeOnEscape]="false">
    <div class="center">
      <div class="col-12" *ngIf="savingTrial && savingTrial > 1">
        <p>{{'UPLOAD_COMPONENT.SAVE_DEPOSIT_TRIAL' | translate}}: {{savingTrial}}</p>
      </div>
      <p *ngIf="depositPersistedSerialLot">{{'UPLOAD_COMPONENT.STATUS_SERIAL_DEPOSIT' | translate}}
        : {{depositPersistedSerialLot}}</p>
      <p-progressBar [value]="progressPersisted"></p-progressBar>
      <div class="col-12" *ngIf="depositPersistedSerialLot">
        <button pButton type="button" (click)="closeLoader()" [label]="'COMMON.CLOSE' | translate"
                class="p-button-danger"></button>
      </div>
      <p></p>
      <p>{{'UPLOAD_COMPONENT.LOADER_HINT' | translate}}</p>
    </div>
  </p-dialog>
</div>
<div *ngIf="openVisualization">
  <p-dialog [styleClass]="'file-display-dialog'" [appendTo]="'body'" [(visible)]="openVisualization"
            [header]="'Je vérifie mon courrier avant de le soumettre '" (onHide)="freeDocMemory(pdfToDisplay)"
            [draggable]="true"
            [closable]="true"
            [maximizable]="true"
            [modal]="true" [closeOnEscape]="true">
    <object *ngIf="pdfToDisplay && !msBrowsers" [data]="pdfToDisplay + '#view=FitH&zoom=100' | safeObjUrl"
            type="application/pdf" width="100%"
            height="100%"></object>
    <!-- <a href="pdfToDisplay">Download PDF</a>-->
  </p-dialog>
</div>
<div *ngIf="displayColumnHelp" class="col-help-modal">
  <p-dialog header="Format de fichier de données" [(visible)]="displayColumnHelp"
            [minY]="70"
            [maximizable]="true" [baseZIndex]="11000"
            [closable]="true"
            [closeOnEscape]="true">
    <div class="col-12">
      <h4>Le contenu</h4>
      <p>Votre fichier de données doit au moins contenir les informations de l'adresse (voir plus bas ).
      </p>
      <p>Vous pouvez ajouter autant de colonnes que vous le souhaiter. Les données qu'elles contiennent peuvent
        être:</p>
      <ul>
        <li>associées au document sous forme de métadonnées (le choix est proposé aprs la sélection du fichier de donnée);</li>
        <li>insérées dans le courrier si vous choisissez le mode création dans l'étape suivante.</li>
      </ul>

      <h4>Le Format</h4>
      <p>Pour une meilleure prise en charge de votre fichier veuillez respecter les règles suivantes </p>
      <ul>
        <li>Le Fichier doit être encodé en UTF-8 (SANS le BOM);</li>
        <li>La valeur d'une cellule ne doit pas dépaser 38 caractères;</li>
        <li>Le nommage de colonnes est sensible à la casse;</li>
        <li>L'ordre des colonnes dans le fichier n'a pas d'importance.</li>
      </ul>
    </div>
    <h4>Les informations de l'adresse</h4>
    <div class="col-12 note-1">
      <div class="col-12">
        <div class="col-3">Destinataire<span>*</span></div>
        <div class="col-9">Qualité, Nom, Prénom, Titre...</div>
      </div>
      <div class="col-12">
        <div class="col-3">Adresse 1<span class="super">**</span></div>
        <div class="col-9">N° Boîte aux lettre, escalier, porte...</div>
      </div>
      <div class="col-12">
        <div class="col-3">Adresse 2<span class="super">**</span></div>
        <div class="col-9">Entrée, Tours, Bâtiment, Résidence...</div>
      </div>
      <div class="col-12">
        <div class="col-3">Adresse 3<span class="super">**</span></div>
        <div class="col-9">N° de la voie, type et nom de la voie</div>
      </div>
      <div class="col-12">
        <div class="col-3">Adresse 4<span class="super">**</span></div>
        <div class="col-9">Lieu dit, Service de distribution BP</div>
      </div>
      <div class="col-12">
        <div class="col-3">Code Postal<span class="super">*</span></div>
        <div class="col-9">Sur cinq chiffres (nous consulter pur l'étranger</div>
      </div>
      <div class="col-12">
        <div class="col-3">Ville<span class="super">*</span></div>
        <div class="col-9">Nom de la localité de distribution</div>
      </div>
      <div class="col-12">
        <div class="col-3">Pays</div>
        <div class="col-9">Par défaut: France</div>
      </div>
      <div class="col-12" *ngIf="hasMailing">
        <div class="col-3">Adresses mail<span class="super">*</span></div>
        <div class="col-9">Adresses e-mail des destinataires</div>
      </div>
      <div class="col-12 note-2"><span class="super">*</span> Colonnes obligatoires</div>
      <div class="col-12 note-2"><span class="super">**</span> Au moins une colonne doit être renseignée.</div>
    </div>
    <p-footer>
      <button type="button" pButton icon="pi pi-check" (click)="displayColumnHelp=false"
              [label]="'COMMON.CLOSE' | translate"></button>
    </p-footer>
  </p-dialog>
</div>
